import './button.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initButtonSection = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  window._klOnsite = window._klOnsite || [];
  const klaviyoId = sectionContainer.querySelector('[data-klaviyo-id]');
  if (klaviyoId)
    klaviyoId.addEventListener('click', (e) => {
      e.preventDefault();
      if (typeof window?._klOnsite?.push !== 'undefined')
        window._klOnsite.push(['openForm', klaviyoId.dataset.klaviyoId]);
    });
};

if (document.readyState != 'loading') {
  [].forEach.call(document.querySelectorAll('.button__section'), (el) => {
    window.dAgency.initButtonSection(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.button__section'), (el) => {
      window.dAgency.initButtonSection(el);
    });
  });
}
